import { BundleBasketFragment } from '@generated/gql/graphql';
import { ReferrerTrackingContext } from '@src/types/tracking';
import { OTSFormValues } from '@src/types/yourDetails';
import { SignupCheckoutEntity } from '@tracking/trackingEvents';
import { parseValueToPennies } from '@utils/price';

import { SubmitBody } from './types';

export const parseCheckoutTrackingContext = (
  basket: BundleBasketFragment,
  application: SubmitBody,
  otsValues: OTSFormValues,
  canSwitch: boolean,
  evInterest: boolean,
  attributionContext: Nullable<ReferrerTrackingContext>
): SignupCheckoutEntity => ({
  actual_monthly_cost: parseValueToPennies(basket.monthlyCost?.value),
  joint_account_holder_added: application.accountHolders.length > 1,
  recent_move: application.recentlyMovedIn,
  cbc_holder_added: false,
  referrer_id: attributionContext?.referrerDetails,
  referrer_type: attributionContext?.referrerType,
  existing_broadband_line: canSwitch ? otsValues.otsHasExistingLine : undefined,
  existing_broadband_provider_not_listed: canSwitch
    ? otsValues.otsProviderNotListed
    : undefined,
  existing_broadband_provider_shortcode: canSwitch
    ? otsValues.otsSelectedProvider?.id
    : undefined,
  ev_expression_of_interest: evInterest,
  energy_usage_category: basket.energy?.details?.predefinedConsumption || '',
});
